import { z } from 'zod'

export const InvestorTypeSchema = z.enum(['Fund', 'Influencer', 'MarketingAgency'])
